// extracted by mini-css-extract-plugin
export var inlineLink = "_96-0";
export var inlineLinkButton = "_96-1";